<template>
  <div class="m-box">
    <div class="user-info">
        <div class="name-icon">
          <img :src="icon || '/static/img/mr-usericon.png'" alt="">
          <div>{{userName}}</div>
        </div>
        <div class="pm-box">
          <div>今日排名 <span>{{signList.todayTop}}</span></div>
          <div>累计打卡<span>{{signList.totalCount}}</span>天</div>
        </div>
    </div>
    <section class="main">
      <div v-for="(item,index) in signList.signList" :key="item.id" :class="[{ first: index == 0 , secend: index == 1 , three: index == 2 },'item-list']" @click="headClick(item.userId , item.uuid)">
        <div class="position-num">{{ index + 1 }}</div>
        <div class="icon-box">
          <img :src="item.userIcon || '/static/img/mr-usericon.png'" alt="">
        </div>
        <div class="name">{{ item.userName }}</div>
      </div>
    </section>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "MSignList",
  data() {
    return {
      userId: this.$route.params.id,
      signList:[],
      userName:'',
      icon:''
    };
  },
  methods: {
    getDataList() {
      this.$api
        .mSignHotList({})
        .then((res) => {
          console.log(res)
          this.signList = res.data.data;
        });
    },
    //进入个人主页
    headClick(uid , uuid){
      var obj = {
        id: uid,
        uuid: uuid,
      }
      let app = this.getEnv();
      if(app=='ios'){
        window.webkit.messageHandlers.headClick.postMessage(obj);
      }else if(app=='android'){
        android.headClick(uid , uuid)
      }
    },
    //判断环境
    getEnv(){
      let ua = window.navigator.userAgent.toLowerCase(),
          app = '';
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        app = 'weixin';
      }else if (ua.indexOf('yydh_android') !== -1) {
        app = 'android'
      }else if (ua.indexOf('yydh_ios') !== -1) {
        app = 'ios'
      }else{
        app = "other"
      }
      return app;
    },
    getUserInfo(){
      let app = this.getEnv();
      this.isWX = false;
      if(app=='ios'){
        this.token = JSON.parse(prompt('getInfo')).token;
        this.icon = JSON.parse(prompt('getInfo')).icon;
        this.userName = JSON.parse(prompt('getInfo')).userName;
        this.currUserId = JSON.parse(prompt('getInfo')).userId;
      }else if(app=='android'){
        this.token = JSON.parse(android.getInfo()).token;
        this.currUserId = JSON.parse(android.getInfo()).userId;
        this.icon = JSON.parse(android.getInfo()).icon;
        this.userName = JSON.parse(android.getInfo()).userName;
      }else{
        this.isWX = true;
      }
      store.state.UserToken = this.token;
      localStorage.setItem('UserToken', this.token);
      this.getDataList();
    },
  },
  created() {
    this.getUserInfo();
  }
};
</script>

<style scoped lang="scss">
.m-box {
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  height: auto;
  background: #317DFF;
  padding-top: 5vw;
  .user-info {
    width: 100%;
    height: 52.53vw;
    display: flex;
    flex-direction: column;
    background: #1f68e4 url('../../assets/images/sign-top-bg.png') no-repeat center top;
    background-size: 100%;
    overflow: hidden;
    .name-icon {
      display: flex;
      align-items: center;
      height: 36.8vw;
      margin-left: 40px;
      img {
        width: 58px;
        height: 58px;
        border-radius: 50%;
      }
      div {
        color: #fff;
        font-size: 20px;
        font-weight: 600;
        margin-left: 12px;
      }
    }
    .pm-box {
      width: 100%;
      height: 12.7vw;
      display: flex;
      color: #fff;
      font-size: 14px;
      justify-content: center;
      justify-content: space-evenly;
      line-height: 12.7vw;

      span {
        font-size: 16px;
        font-weight: 600;
        color: #FFDF11;
      }
    }
  }
  .main {
    background: #fff;
    padding: 15px 24px;
    margin-top: -4vw;
    border-radius: 5.33vw 5.33vw 0 0;
    min-height: 500px;
    .item-list {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .position-num {
        font-size: 15px;
        margin-right: 16px;
        color: #999999;
      }
      .icon-box {
        width: 54px;
        height: 54px;
        text-align: center;
        padding: 8px 0;
        margin-right: 13px;
        img {
          width: 38px;
          height: 38px;
          border-radius: 50%;
        }
      }
      .name {
        font-size: 15px;
        font-weight: 600;
        color: #333333;
      }
    }
    .first {
      .position-num {
        color: #E4BA00;
        font-weight: 600;
      }
      .icon-box {
        background: url('../../assets/images/sign-first-icon.png') no-repeat left top;
        background-size: 18px 17px;
        img {
          border: 1px solid #FFD000;
        }
      }
    }
    .secend {
      .position-num {
        color: #9F9E9E;
        font-weight: 600;
      }
      .icon-box {
        background: url('../../assets/images/sign-secend-icon.png') no-repeat left top;
        background-size: 18px 17px;
        img {
          border: 1px solid #CFCFCF;
        }
      }
    }
    .three {
      .position-num {
        color: #F09C0F;
        font-weight: 600;
      }
      .icon-box {
        background: url('../../assets/images/sign-three-icon.png') no-repeat left top;
        background-size: 18px 17px;
        img {
          border: 1px solid #F6BB58;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/m/SignList.vue